import classNames from 'classnames';
import { useTranslation } from 'react-i18next';

import type { Country } from '../../../features/geography/types';

import styles from './CountryCodeDisplay.module.scss';
import internationalIcon from './internationalIcon.svg';

export function CountryCodeDisplay(props: { country?: Country }) {
  const { t } = useTranslation();
  const imageSrc = props.country?.code
    ? `https://catamphetamine.github.io/country-flag-icons/3x2/${props.country?.code}.svg`
    : internationalIcon;

  return (
    <div className={styles.displayWrapper}>
      <img alt={props.country?.code} className={styles.flagIcon} src={imageSrc} />
      <span className={classNames([styles.callingCode, { [styles.placeholder]: !props.country?.name }])}>
        {props.country?.name ?? t('forms.selectCountry')}
      </span>
    </div>
  );
}
